// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentPaymentPaymentMethodPaymentMethodResponse {
    static getAttributeTypeMap() {
        return EnrollmentPaymentPaymentMethodPaymentMethodResponse.attributeTypeMap;
    }
}
EnrollmentPaymentPaymentMethodPaymentMethodResponse.discriminator = undefined;
EnrollmentPaymentPaymentMethodPaymentMethodResponse.additionalProperties = false;
EnrollmentPaymentPaymentMethodPaymentMethodResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentV2PaymentTypeModels"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=enrollmentPaymentPaymentMethodPaymentMethodResponse.js.map